export const OPERATION_TYPES = {
  REAL_ESTATE_CLUB_DEAL: "REAL_ESTATE_CLUB_DEAL",
  PRIVATE_FINANCING: "PRIVATE_FINANCING",
  CROWDFUNDING: "CROWDFUNDING",
  VENDOR_LOAN: "VENDOR_LOAN",
  REAL_ESTATE_CARRYING: "REAL_ESTATE_CARRYING",
  SALE_WITH_RIGHT_OF_REDEMPTION: "SALE_WITH_RIGHT_OF_REDEMPTION",
  OTHER_INTERMEDIATION: "OTHER_INTERMEDIATION",
};

export const OPERATION_TYPES_LABELS = {
  [OPERATION_TYPES.REAL_ESTATE_CLUB_DEAL]: "Club-deal Immobilier",
  [OPERATION_TYPES.PRIVATE_FINANCING]: "Financement Privé",
  [OPERATION_TYPES.CROWDFUNDING]: "Crowdfunding",
  [OPERATION_TYPES.VENDOR_LOAN]: "Crédit Vendeur",
  [OPERATION_TYPES.REAL_ESTATE_CARRYING]: "Portage Immobilier",
  [OPERATION_TYPES.SALE_WITH_RIGHT_OF_REDEMPTION]: "Vente à Réméré",
  [OPERATION_TYPES.OTHER_INTERMEDIATION]: "Autre Intermédiation",
};
